import { render, staticRenderFns } from "./green.vue?vue&type=template&id=488800bf&scoped=true"
import script from "./green.vue?vue&type=script&lang=js"
export * from "./green.vue?vue&type=script&lang=js"
import style0 from "./green.vue?vue&type=style&index=0&id=488800bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488800bf",
  null
  
)

export default component.exports